import React from "react";
import { Link } from "gatsby";

import { pageWidth } from "../constants";

const Footer = class extends React.Component {
  render() {
    return (
      <div
        style={{
          borderTop: "1px solid #bbb",
          maxWidth: "100%",
        }}
      >
        <div class="mx-auto" style={{ width: pageWidth, maxWidth: "100%" }}>
          <div class="m-2 flex flex-row justify-between">
            <div class="flex flex-row">
              <div class="font-serif text-gray-600 mr-8">
                Scientia pigeon est
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Footer;
